/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { DatabaseSnapshot } from '@angular/fire/compat/database';
import { IProjectFile, ProjectFile } from '../../../app-data/models/ProjectFile';
import { IFancyIdJoin } from '../base/FancyIdJoin';
import { AngularLandConnection } from '../base/interfaces';
import { LocalAction } from '../base/LocalSnapshot';
import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { DefaultSplitDataRenderType } from '@touchplan/common';

export class ProjectFileList extends FancyFirebaseSplitDataList<
	IProjectFile,
	DefaultSplitDataRenderType,
	ProjectFile
> {
	constructor(angularLand: AngularLandConnection, path: any, fancyJoins?: IFancyIdJoin) {
		super(angularLand, path, fancyJoins);
	}

	public $$added(action: LocalAction<DatabaseSnapshot<any>>) {
		const definition = new ProjectFile(action.payload.key);
		definition.databaseUpdate(action.payload.val());
		return definition;
	}
}
